import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage, { headerTypes } from 'hoc/websitePage/websitePage';
import { CREDIT_CARD } from 'utils/prospectTypes';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionMastercard from './patterns/SectionMastercard/SectionMastercard';
import SectionWanted from './patterns/SectionWanted/SectionWanted';
import SectionFeatures from './patterns/SectionFeatures/SectionFeatures';
import SectionNoTaxes from './patterns/SectionNoTaxes/SectionNoTaxes';
import SectionKnowMore from './patterns/SectionKnowMore/SectionKnowMore';

export function CreditCard({ onFormVisibilityChange }) {
  const { formatMessage } = useContext(NuDsContext);

  const cardsArea = formatMessage({ id: 'cms.cardPage.cardCardsArea' });

  const cardsMap = {
    SectionMastercard,
    SectionWanted,
    SectionFeatures,
    SectionNoTaxes,
    SectionKnowMore,
  };

  return (
    <>
      <SectionForm
        onFormVisibilityChange={onFormVisibilityChange}
      />
      {cardsArea.map((cardCard, index) => {
        const CardComponent = cardsMap[cardCard.componentName];

        if (!CardComponent) return null;

        return (
          <CardComponent
            key={cardCard.id}
            index={index}
          />
        );
      })}
    </>
  );
}

CreditCard.propTypes = {
  onFormVisibilityChange: PropTypes.func,
};

CreditCard.defaultProps = {
  onFormVisibilityChange: () => {},
};

export default websitePage({
  routeKey: 'CARD',
  widgetProspectType: CREDIT_CARD,
  header: headerTypes.PRODUCT_PAGE,
})(CreditCard);
